import { h, Component } from 'preact';
import pure from 'utils/pure';
import { accessNested, sortObjectByOrder, joinClasses } from 'utils/utils';
import { getPath } from 'utils/clientUtils';
import { updateDataLayer } from 'utils/tracking';
import Reveal from 'components/shared/reveal/reveal.js';
import { Link } from 'components/core/link/link';
import { getCopy } from 'utils/copy';
import { track } from 'utils/tracking';
import Store from 'store/store';
import * as actions from 'store/actions';
import * as svg from 'components/shared/svgIcons/svgIcons.js';
import s from 'components/shared/social/social.sss';

// Changes a relative link (e.g. '../abc/file.txt') to a full url (e.g. 'http://site.com/dir/abc/file.txt')
function relativeToAbsolute(relative, def) {
	if (typeof document === 'undefined') return def;
	const a = document.createElement('a');
	a.href = relative;
	return a.href;
}

export default @pure class Social extends Component {

	getShareCopy(copy, attr) {
		let socialCopy = getCopy(attr || '$SOCIAL_COPY');

		// Backward compatibility. We used SOCIAL_MESSAGE property before
		socialCopy = socialCopy || getCopy('$SOCIAL_MESSAGE');

		return socialCopy || '';
	}

	getShareUrl() {
		let customShareUrl = getCopy('$SHARE_URL');

		// Backward compatibility. We used SOCIAL_MESSAGE_LINK property before
		customShareUrl = customShareUrl || getCopy('$SOCIAL_MESSAGE_LINK');

		return customShareUrl;
	}

	getChildrenArray(appUrl) {
		appUrl = encodeURIComponent(appUrl);
		let customShareUrl = this.getShareUrl();

		if (customShareUrl.length > 0) {
			appUrl = encodeURIComponent(customShareUrl);
		}

		const items = this.props.items;
		const pageData = this.props.appData.pages[this.props.activePage.id].data || {};

		if (!items) {
			return [];
		}

		return sortObjectByOrder(items, (item, key) => {
			// 2017-08-25: Here there used to be some code for WhatsApp.
			// Removed it as it was duplicated (check https://goo.gl/qRpCZB)
			let iconId = item.id || key;
			iconId = iconId[0].toUpperCase() + iconId.slice(1);
			let baseShareUrl = item.shareUrl || accessNested(this.props, ['appData', 'meta', 'social', key, 'link']) || '';
			let unparsedSharePath = baseShareUrl
				.replace(/%SHARE_URL%/g, appUrl)
				.replace(/%SHAREURL%/g, appUrl) //Fix for apps that were mistakenly created with this variable. Remove in 2020
				.replace(/%ENCODED_MESSAGE%/g, getCopy('$ENCODED_MESSAGE'))
				.replace(/%SOCIAL_COPY%/g, encodeURIComponent(this.getShareCopy(pageData, pageData.shareCopy)))
				.replace(/%SOCIALCOPY%/g, encodeURIComponent(this.getShareCopy(pageData, pageData.shareCopy))) //Fix for apps that were mistakenly created with this variable. Remove in 2020
				.replace(/%MOVIE_NAME%/g, accessNested(this.props, ('appData.meta.title.locale' || 'appData.meta.title.en')))
				.replace(/%ALBUM_NAME_AND_ID%/g, getCopy('$ALBUM_NAME_AND_ID'));

			// encode twitter hashtags when %SOCIAL_COPY% doesn't exist in baseShareUrl
			if ((item.id === 'Twitter' || item.id === 'Whatsapp') && unparsedSharePath.includes('#')) {
				unparsedSharePath = unparsedSharePath.replace(/#/g, '%23');
			}
			const parsedSharePath = unparsedSharePath.replace(/%IMAGE_REGION_ROOT%/g, this.props.appData.urls.roots.imageRegion);

			return {
				id:      key,
				class:   joinClasses(s.icon, s['icon' + iconId], this.props.sideNav && s.iconSideNav),
				href:    parsedSharePath,
				title:   item.title,
				trackId: item.trackId,
				target:  item.target || '_blank'
			};
		});
	}

	getHashtagText() {
		let {
			titleCopy,
			appData
		} = this.props;
		let hashtagText = (titleCopy && getCopy(titleCopy)) || getCopy('HASHTAG');

		const imageHashtag = /^[^#].+\..+$/.test(hashtagText);
		if (imageHashtag) {
			hashtagText = <div class={s.hashtagImage} style={{ backgroundImage: 'url(' + appData.urls.roots.image + '/' + hashtagText + ')' }} />;
		}

		return hashtagText;
	}

	getSocialText() {
		return getCopy('SHARE');
	}

	render(props) {
		const {
			appData,
			activePage,
			socialClass,
			sideNav,
			iconClass,
			color,
			titleCopy,
			iconStyle,
			noRevealer,
			notHeader
		} = props;

		// Keep that a let, not a const
		let {
			appUrl
		} = props;

		const { copy } = appData;

		const extraSocialClass = s.socialWrapper;
		let buttonText = this.getSocialText();

		// 10/20/20: Disabled to prevent relativePath changing from appData.meta.url to local path
		// if (appUrl === appData.meta.url) {
		// 	const relativePath = (getPath(activePage).substring(1).match(/\//g) || []).map(() => ('../')).join('');
		// 	appUrl = relativeToAbsolute(relativePath, appUrl);
		// }

		const childrenArray = this.getChildrenArray(appUrl);
		let image = '';
		this.linkList = childrenArray.map((child) => {
			if (child.imgPath) {
				image = <img class={s.icon} src={child.imgPath} />;
			}

			let onClick;
			if (child.onClick) {
				onClick = child.onClick;
			}

			// TODO: quick fix, refactor that a bit
			const finalOnClick = (event) => {
				updateDataLayer({ event: 'social-click', socialSite: child.id });
				Store.emit(actions.CLICKED_SHARE, child.id);
				// track({ a: 'share-link-' + child.id });
				if (typeof onClick === 'function') onClick(event);

				// ? This has no relation to the quiz component. Should not be here.
				if (window.location.search.indexOf('showbarebones') > -1) {
					track({ a: 'barebones-quiz-shared' });
					track({ a: `barebones-quiz-share-${child.id}` });
				}
			};

			const shareAriaLabel = (copy.$ARIALABEL_SHARE_ON_PLATFORM || '') + (copy.$ARIALABEL_SHARE_ON_PLATFORM && ' ') + child.title + (copy.$ARIALABEL_SHARE_ON_PLATFORM_AFTER && ' ') + (copy.$ARIALABEL_SHARE_ON_PLATFORM_AFTER || '');

			// child.trackId is switched to be label because we need track action to be 'share_click'
			return (
				<div class={child.class}>
					<Link
						ref={e => this.$link = e}
						href={child.href}
						extraOnClick={finalOnClick}
						target={child.target ? child.target : '_blank'}
						trackId={"share_click-" + child.id}
						trackLabel={child.trackId}
						renderCustomChild
						ariaLabel={shareAriaLabel}
					>
						{image}
						{/* <p class={s.text}>{child.title}</p> */}
					</Link>
				</div>
			);
		});

		const hashtagStyles = !sideNav || this.props.forceHashtagStyles;
		let hashtagText = this.getHashtagText();
		let hashtagEl = null;


		if (hashtagText && titleCopy) {
			buttonText = hashtagText;
		}

		if (hashtagText && hashtagStyles) {
			buttonText = hashtagText;
			// if(imageHashtag) {
			// 	buttonText = <div class={s.hashtagImage} style={{backgroundImage: 'url('+appData.urls.roots.image+'/'+buttonText+')'}} />;
			// }
			// TODO: improve this
			const titleClass = iconClass ? s.iconClass : s.hashtag;
			let icon;
			if (iconClass) {
				const IconComponent = svg[iconClass];
				icon = <IconComponent color={color} class={s.iconSvg}/>;
			} else if (iconStyle) {
				icon = <div style={iconStyle} class={s.iconLinkUrl} />;
			}
			hashtagEl = <div class={titleClass}>{icon}<span>{this.getSocialText()}</span></div>;
		}

		let extra = '';

		if (sideNav && accessNested(appData, 'options.sideNavHashtag')) {
			extra = <div class={s.sideNavHashtag}>{hashtagText}</div>;
		}

		let classNameRaw = 'shareWrapper';
		if (!notHeader) {
			classNameRaw += 'Header';
		}
		if (!hashtagStyles) {
			classNameRaw += 'Sidebar';
		}

		return (
			<div class={joinClasses(extraSocialClass, socialClass, noRevealer && s.show)}>
				{hashtagEl}
				<Reveal
					linkList={this.linkList}
					sourceContainer={'social-share' + (sideNav ? '-side' : '')}
					wrapperClass={hashtagStyles ? '' : s.shareSocialWrapperSidebar}
					revealClass={s[classNameRaw]}
					revealWrapper={hashtagStyles ? s.buttonWrapper : s.buttonWrapperNavSidebar}
					shouldTransform={!!hashtagStyles}
					mobileVisible={sideNav}
					buttonText={buttonText}
					titleClass={hashtagStyles ? '' : s.sideNavTitle}
					show={noRevealer}
				/>
				{extra}
			</div>
		);
	}

}
